import { z } from 'zod';
/**
 * Terminarten (KON-066): Jeder Mandant legt in der Einrichtung selbst fest, welche Arten von Terminen er hat, zum Beispiel „Meeting“, „Kundentermin“, „Workshop“.
 * Ein Termin hat höchstens eine Art. Jede Art hat eine Farbe aus einer festen Auswahl, damit der Kalender die Arten auseinanderhält.
 */
export const APPOINTMENT_TYPE_COLORS = ['teal', 'blue', 'violet', 'amber', 'red', 'green', 'slate', 'pink'];
export const isHexColor = (v) => /^#[0-9a-f]{6}$/.test(v);
export const APPOINTMENT_TYPE_COLOR_LABELS = {
    teal: 'Türkis',
    blue: 'Blau',
    violet: 'Violett',
    amber: 'Orange',
    red: 'Rot',
    green: 'Grün',
    slate: 'Grau',
    pink: 'Rosa',
};
const name = z.string().trim().min(2, 'Bezeichnung fehlt').max(60, 'Höchstens 60 Zeichen');
/** Prüfung einer Farbe: ein Name der Vorgaben oder `#rrggbb`, Groß- und Kleinschreibung gleich */
export const typeColorInput = z
    .string('Bitte eine Farbe wählen')
    .trim()
    .toLowerCase()
    .refine((v) => APPOINTMENT_TYPE_COLORS.includes(v) || isHexColor(v), 'Bitte eine Farbe wählen');
/** Bezeichnung für Listen: der Name der Vorgabe oder der Farbwert */
export const colorLabel = (color) => APPOINTMENT_TYPE_COLOR_LABELS[color] ?? color.toUpperCase();
const color = typeColorInput;
export const createAppointmentTypeInput = z.object({ name, color: color.default('teal') });
export const updateAppointmentTypeInput = z
    .object({ name: name.optional(), color: color.optional() })
    .strict()
    .refine((v) => Object.values(v).some((x) => x !== undefined), 'Keine Änderung angegeben');
/** Neue Reihenfolge: alle Arten, in der Reihenfolge, in der sie stehen sollen */
export const reorderAppointmentTypesInput = z.object({ ids: z.array(z.uuid('Ungültige Art')).min(1).max(200) });
//# sourceMappingURL=appointment-types.js.map